/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionEditService } from './action-edit.service';
import { Observable } from 'rxjs';
import { ToastMessageOptions } from 'primeng/api';
import { ErrorService } from '@irian-ro/shared-components-module';
import { ActionDefinitionDtoModel, ActionDefinitionMetaDataModel } from '@well/domain';
import { JsonApiResource } from '@irian-ro/abstract-resource';

@Component({
  selector: 'well-action-edit-page',
  templateUrl: './action-edit-page.component.html',
  styleUrls: ['./action-edit-page.component.scss']
})
export class ActionEditPageComponent {
  get uuid(): string | undefined {
    return this._uuid;
  }

  @Input()  set uuid(value: string) {
    this._uuid = value;

    if(value) {
      this.actionEditService.findOne(this.uuid).subscribe(
        (res: JsonApiResource<ActionDefinitionDtoModel, ActionDefinitionMetaDataModel>) => {
          this.action = res.data;
          this.meta = res.meta;
        }
      );
    }
  }

  action: ActionDefinitionDtoModel | null = null;

  @Input() subscriptionTypeUuid : string | undefined = undefined;

  private _uuid : string | undefined = undefined;

  @Output() saveSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancelOperation: EventEmitter<void> = new EventEmitter<void>();

  msg: Observable<ToastMessageOptions[]> | undefined = undefined;

  meta: ActionDefinitionMetaDataModel | undefined = undefined;

  constructor(private actionEditService: ActionEditService,
              private router: Router,
              private route: ActivatedRoute,
              private errorService: ErrorService) {
  }

  onActionSubmit(action: any) {
    this.actionEditService.save(action).subscribe(
      data => {
        this.uuid = data._uuid;
        this.saveSuccess.next(true);

      },
      error => {
        this.msg = this.errorService.prepareErrorsForDisplay(error, 'company.actions.errors');
      }
    );
  }

  goBack() {
    this.cancelOperation.next();
  }

}
